import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ImageCroppedEvent,
  ImageCropperComponent
} from "ngx-image-cropper";

@Component({
  selector: 'app-avatar-editor',
  templateUrl: './avatar-editor.component.html',
  styleUrls: ['./avatar-editor.component.css']
})
export class AvatarEditorComponent {

  @Input() original_image: string;
  @Input() roundCropper: boolean;
  @Output() imageCroppedEvent = new EventEmitter();
  @Output() inEsecution: EventEmitter<boolean> = new EventEmitter();

  @ViewChild(ImageCropperComponent, { static: false }) cropper!: ImageCropperComponent;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  imageChangedEvent: any = '';
  croppedImage: string = '';
  showCropper: boolean;

  imageCropped(event: ImageCroppedEvent){
    this.croppedImage = event.objectUrl!;
  }

  cropManually() {
    const event: ImageCroppedEvent = this.cropper.crop('base64');  // <-- chiave!
    this.croppedImage = event.base64 ?? null;
    if(this.croppedImage){
      this.imageCroppedEvent.emit(this.croppedImage);
    }
    this.showCropper = false;
    this.inEsecution.emit(false);
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  fileChangeEvent(event: Event): void {
    this.showCropper = true;
    this.inEsecution.emit(true);
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      this.imageChangedEvent = event; // per il cropper
    }
  }

}
